<div
  [ngClass]="[
    hasAnyGroup() ? 'vertical-group' : alignment === 'vertical' ? 'vertical-group' : 'horizontal-group',
    labelPosition === 'left' ? 'group-left' : '',
  ]">
  @for (item of items; track $index) {
    @if (item.children && item.children.length > 0) {
      <mat-checkbox
        class="sg-ui-component"
        [disableRipple]="true"
        [checked]="areAllChildrenChecked(item)"
        [indeterminate]="isIndeterminate(item)"
        [disabled]="disabled"
        (change)="onValueChange(item)"
        [class.error]="errorMessage"
        [class.label-left]="labelPosition === 'left'">
        <sg-text variant="sg-label-medium-regular" [color]="item.labelColor ?? ''">{{ item.label }}</sg-text>
      </mat-checkbox>
      <div class="checkbox-group-children vertical-group">
        @for (child of item.children; track $index) {
          <mat-checkbox
            class="sg-ui-component"
            [disableRipple]="true"
            [checked]="child.checked"
            [disabled]="disabled"
            (change)="onValueChange(child, item)"
            [class.error]="errorMessage"
            [class.label-left]="labelPosition === 'left'">
            <sg-text variant="sg-label-medium-regular" [color]="child.labelColor ?? ''">{{ child.label }}</sg-text>
          </mat-checkbox>
        }
      </div>
    } @else {
      <mat-checkbox
        class="sg-ui-component"
        [disableRipple]="true"
        [checked]="item.checked"
        [disabled]="disabled"
        (change)="onValueChange(item)"
        [class.error]="errorMessage"
        [class.label-left]="labelPosition === 'left'">
        <sg-text variant="sg-label-medium-regular" [color]="item.labelColor ?? ''">{{ item.label }}</sg-text>
      </mat-checkbox>
    }
  }
</div>
@if (errorMessage) {
  <sg-text variant="sg-body-small-regular" class="error-message">{{ errorMessage }}</sg-text>
}
